import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        productcombos: false,
    },
};

@observer
class ProductComboList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { productComboStore } = this.props.stores;
        productComboStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { productComboStore } = this.props.stores;
        const { totalAppend, limit } = productComboStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = productComboStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                productComboStore.updateOffset(offset);
                await productComboStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { productComboStore } = this.props.stores;
        productComboStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { productComboStore } = this.props.stores;
        await productComboStore.saveField(id, field, value);
    }

    createNewProductCombo = async () => {
        const { productComboStore } = this.props.stores;
        await productComboStore.create({
            name: 'Untitled',
        });
        await productComboStore.list();
    }

    render() {
        const { loading } = this.state;
        const { productComboStore } = this.props.stores;
        const { productCombos, queryFilter, saved } = productComboStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2 ml-4'>
                            Total: {productComboStore.total}<br />
                        </small>

                        <button class={`ml-2 float-right btn btn-sm btn-success`}
                            onClick={this.createNewProductCombo}
                        >
                            <i class='far fa-file mr-2' />
                            New Product combo
                        </button>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for productcombos...'
                                    onInput={e => productComboStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => productComboStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {productComboStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => productComboStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {productComboStore.sort !== productComboStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => productComboStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => productComboStore.toggleSort('id', '')}>
                                                Combo# {util.getSortIcon('id', productComboStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => productComboStore.toggleSort('name', '-')}>
                                                Name {util.getSortIcon('name', productComboStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => productComboStore.toggleSort('sort', '')}>
                                                sort {util.getSortIcon('sort', productComboStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => productComboStore.toggleSort('groupno', '-')}>
                                                Groupno {util.getSortIcon('groupno', productComboStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-center'>
                                            <span class={style.pointerCursor} onClick={() => productComboStore.toggleSort('singleIsOk', '-')}>
                                                singleIsOk {util.getSortIcon('singleIsOk', productComboStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 30%'>Group A</th>
                                        <th style='width: 30%'>Group B</th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => productComboStore.toggleSort('createdDate', '-')}>
                                                Created {util.getSortIcon('createdDate', productComboStore.sort)}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productCombos && productCombos.map(productcombo => (
                                        <tr class={`${style.tableline}`}>
                                            <td class='text-right'>
                                                {productcombo.id}
                                            </td>
                                            <td>
                                                <a href={`/productcombos/${productcombo.id}/Basics`}>{productcombo.name}</a>
                                            </td>
                                            <td>
                                                <Input
                                                    id={productcombo.id}
                                                    className='text-right form-control-sm'
                                                    isValid={saved[`sort.${productcombo.id}`]}
                                                    name='sort'
                                                    value={productcombo.sort}
                                                    onInput={e => this.updateField(productcombo.id, 'sort', e.target.value)}
                                                    hideHelp={1}
                                                />
                                            </td>
                                            <td>
                                                {productcombo.groupno}
                                            </td>
                                            <td class='text-center'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-${util.colorClass(productcombo.singleIsOk, 'yesno')}`}
                                                    onClick={() => productComboStore.saveField(productcombo.id, 'singleIsOk', util.cyclevalues(productcombo.singleIsOk, [0, 1]), true)}
                                                >
                                                    {util.statusText(productcombo.singleIsOk, 'yesno')}
                                                </span>
                                            </td>
                                            <td>
                                                {productcombo.groupA && productcombo.groupA.join(', ')}
                                            </td>
                                            <td>
                                                {productcombo.groupB && productcombo.groupB.join(', ')}
                                            </td>
                                            <td class='text-right'>
                                                {productcombo.createdDate && util.ffeDateTime(productcombo.createdDate)}
                                                {productcombo.updatedDate && <div><small class='text-muted'><i class='fas fa-edit' /> {util.ffeDateTime(productcombo.updatedDate)}</small></div>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default ProductComboList;




// WEBPACK FOOTER //
// ./components/productcombos/list.js